import type { PubSub } from '../../PubSub';
import type { GameEvents } from '../../events';

export class SpawnBeings {
    constructor(private count: number) {}

    execute(pubsub: PubSub<GameEvents>, _flag: { cancelled: boolean }): Promise<void> {
        return pubsub.publish('world:spawn-beings', this.count);
    }
}
